<template>
    <div>
        <b-btn @click="printOrders" class="ml-3" variant="link" :disabled="progressing">
            <span class="text-link" v-if="!progressing">
                Print Item List by Due...
            </span>
            <span v-else>
                Please wait...
            </span>
            <!--            <font-awesome-icon icon="print" class="align-middle mx-2"/>-->
        </b-btn>
        <vue-easy-print ref="easyPrint">
            <template slot-scope="func">
                <b-container>
                    <b-table-simple striped class="w-100 special-table">
                        <b-thead>
                            <!-- <b-tr>
                                <b-td colspan="8">
                                    <div class="text-center">
                                        <p>
                                            {{info.RestaurantName}}, {{info.RestaurantAddress}}
                                        </p>
                                        <p class="mb-0">Special Event: {{choosedMenuType.MenuType}}      Tabs: {{items.length}} active
                                            <span v-if="canceledItem.length">
                                                , {{canceledItem.length}} canceled
                                            </span>
                                        </p>
                                    </div>
                                </b-td>
                            </b-tr> -->
                            <b-tr>
                                <b-th>Due</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in items" :key="index" class="border-bottom-0">
                                <b-td>{{$convertDate(item.DueTime)}}</b-td>
                                <b-tr >
                                   
                                    <b-td colspan="4" >
                                        <div v-for="(child, index) in item.FoodList" :key="index" class="table-row-data">
                                            <div>
                                                {{child.Quantity + 'x'}}
                                                <span class="ml-1">
                                                    {{child.ItemName}}
                                                </span>
                                                <span style="color: #3d5afe !important" v-if="child.Alcoholic" class="font-weight-bold mx-5">
                                                    * ALC. VERIFY AGE *
                                                </span>
                                            </div>
                                            <div class="text-danger ml-4">
                                                {{child.PriceComment}}
                                            </div>
                                            <div class="font-weight-bold ml-4" style="color: red">
                                                {{child.Modifiers}}
                                            </div>
                                            <div class="text-danger ml-4 font-weigth-bold">
                                                {{child.Description}}
                                            </div>
                                        </div>
                                    </b-td>
                                </b-tr>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-container>
            </template>
        </vue-easy-print>
    </div>
</template>

<script>
    import vueEasyPrint from "vue-easy-print";

    export default {
        name: "printSpecialOrderByDue",
        components: {
            vueEasyPrint
        },
        props: {
            filter: {required: true},
            menuTypes: {required: true},
            menuTypeId: {required: true}
        },
        data () {
            return {
                progressing: false,
                items: [],
                info: {}
            }
        },
        computed: {
            canceledItem () {
                return this.items && this.items.filter(i => i.OrderStatusID === 5)
            },
            choosedMenuType () {
                return this.menuTypes.find(item => item.MenuTypeID === this.menuTypeId)
            }
        },
        methods: {
            printOrders () {

                const filter = this.filter
                filter.IsLive = 1
                
                //filter.Serve_Type = "FullyServed"
                //filter.Sort = ""
                //filter.BlockSize="5"
                
                this.progressing = true
                return this.$api.getRestaurant.GetOrderItemsByDueDate_Event(filter).then(res => {
                    this.progressing = false
                    if (res.success) {
                        this.info = res.results
                        this.arrangeFoods(res.results)
                        this.$nextTick(() => {
                            this.$refs.easyPrint.print()
                        })
                }
                })
            },
            arrangeFoods(list){
                let tmp = []
                for(let i = 0; i < list.length; i++){
                    if(!tmp.find(el=>el.DueTime === list[i].DueTime)){
                        let obj = {
                            DueTime: list[i].DueTime,
                            FoodList: []
                        }
                        obj.FoodList.push(list[i])
                        tmp.push(obj)
                    }else{

                         let idx = tmp.indexOf(tmp.find(el=>el.DueTime === list[i].DueTime))
                         
                         
                         let found = tmp[idx].FoodList.indexOf(tmp[idx].FoodList.find(el=>{
                                return list[i].ItemName === el.ItemName && list[i].Description === el.Description && list[i].PriceComment === el.PriceComment && list[i].Modifiers === el.Modifiers
                            }))
                         if(found != -1){//is found
                            tmp[idx].FoodList[found].Quantity += list[i].Quantity
                         }else{
                             tmp[idx].FoodList.push(list[i])
                         }
                    }
                }

                
                for(let i = 0;i < tmp.length; i++){
                    let drinks = tmp[i].FoodList.filter(el=>el.DrinkID != 0).sort((a,b)=>a.ItemName.localeCompare(b.ItemName))
                    let foods = tmp[i].FoodList.filter(el=>el.FoodID != 0).sort((a,b)=>a.ItemName.localeCompare(b.ItemName))
                    tmp[i].FoodList = []
                    tmp[i].FoodList = [...foods,...drinks]
                }
                this.items = tmp

            }
        }
    }
</script>

<style scoped>
    @media print {
        *{
            background: #fff !important;
        }
    }
    .table-row-data{
        margin-left: 15rem;
    }
    /*.printOrders{*/
    /*    display: none;*/
    /*}*/

    /*@media print {*/
    /*    .printOrders{*/
    /*        display: block;*/
    /*    }*/
    /*}*/
</style>
